import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getCurrentStorageUser } from '../../common/localStorage/currentStorageUser'

export const useUserStore = defineStore('user', () => {
    const subscribedUser = ref(undefined)

    const setUser = (user) => {
        subscribedUser.value = user
        persistToLocalStorage()
    }

    const getPiniaStorageKey = () => {
        return getCurrentStorageUser() + '@pinia'
    }

    const persistToLocalStorage = () => {
        const key = getPiniaStorageKey()
        try {
            let data = {}
            const stored = localStorage.getItem(key)
            if (stored) {
                try {
                    data = JSON.parse(stored)
                } catch (e) {
                    console.warn('Failed to parse existing Pinia localStorage, creating new:', e)
                    data = {}
                }
            }

            data.userStore = {
                subscribedUser: subscribedUser.value,
            }

            localStorage.setItem(key, JSON.stringify(data))
        } catch (e) {
            if (e.name === 'QuotaExceededError' || e.message.includes('quota')) {
                console.warn('QuotaExceededError detected in user store')
                throw e
            }
        }
    }

    const loadFromLocalStorage = () => {
        const key = getPiniaStorageKey()
        try {
            const stored = localStorage.getItem(key)
            if (stored) {
                const data = JSON.parse(stored)
                if (data.userStore && typeof data.userStore.subscribedUser !== 'undefined') {
                    subscribedUser.value = data.userStore.subscribedUser
                }
            }
        } catch (e) {
            console.warn('Failed to load user from localStorage:', e)
        }
    }

    loadFromLocalStorage()

    return {
        subscribedUser,
        setUser,
    }
})
